function LazyLoadObserver(element, onHit, options) {
    let observer;
    let loading;
    let stopped;
    let inRange;
    let config;
    let margin;

    loading = false;
    stopped = false;
    inRange = false;

    margin = options && options.margin ? options.margin : 1;

    config = {
        root: null,
        rootMargin: `0px 0px ${margin}px 0px`,
        threshold: 0
    };

    function maybeLoad() {
        if (loading || stopped || !inRange) {
            return;
        }

        loading = true;

        onHit().then(hasMore => {
            loading = false;

            if (stopped) {
                return;
            }

            if (hasMore && inRange) {
                maybeLoad();
            }
        }).catch(() => {
            loading = false;
        });
    }

    function handleIntersect(entries) {
        let entry;

        entry = entries[0];

        inRange = !!(entry && entry.isIntersecting);

        if (inRange) {
            maybeLoad();
        }
    }

    return {
        start: function () {
            if (observer) {
                maybeLoad();
                return;
            }

            stopped = false;
            observer = new IntersectionObserver(handleIntersect, config);
            observer.observe(element);
        },

        stop: function () {
            stopped = true;
            inRange = false;
            loading = false;

            if (observer) {
                observer.unobserve(element);
                observer.disconnect();
                observer = null;
            }
        }
    };
}
